import styled from '@emotion/styled'

export const Background = styled.div`
    width: 100%;
    position: relative;
    padding-top: 128px;
    padding-bottom: 64px;
    z-index: 0;
    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        display: flex;
        flex-direction: column;
        gap: 56px;
        align-items: flex-start;
        padding-bottom: 0px;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        padding-bottom: 0px;
    }
`

const HeroHeader = styled.div`
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.primaryColor.grey[1]};
`

export const HeroMainHeader = styled(HeroHeader)`
    width: 100%;
    max-width: ${(props) => props.theme.containerWidth};
    position: relative;
    z-index: 2;
    margin: 20px auto 0 auto;
    gap: 16px;
    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        justify-content: center;
        align-items: center;
    }
`

export const HeroTextHeader = styled.div`
    width: 392px;
    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        width: unset;
    }
`

export const HeroNameHeader = styled(HeroHeader)`
    gap: 4px;

    h1 {
        font-family: Yantramanav-Bold;
        letter-spacing: -3px;
        font-size: 64px;
        margin-bottom: -32px;
        margin-top: unset;
    }

    h2 {
        font-family: Inter-Light;
        font-size: 20px;
        margin-top: 24px;
        max-width: 392px;
        font-weight: 200;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        justify-content: center;
        align-items: center;
        text-align: center;
        margin: 0 16px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        h1 {
            font-size: 56px;
        }
    }
`

export const CheckMainHeader = styled.div`
    display: flex;
    margin-top: 4px;
    fled-direction: row;
    gap: 32px;
`

export const CheckContentHeader = styled(CheckMainHeader)`
    font-weight: 700;
    gap: 8px;
`

export const ImageWrapper = styled.img`
    position: absolute;
    top: 98px;
    right: 0;
    width: 50%;
    height: 369px;
    object-fit: cover;
    z-index: 1;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        position: static;
        align-self: flex-end;
        width: 100%;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        object-fit: cover;
        height: unset;
    }
`

export const HeroSocialsWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 32px;
`

export const HeroSocials = styled.img`
    width: 32px;
    height: 32px;
`

export const ButtonsContainer = styled.div`
    display: flex;
    max-width: 392px;
    justify-content: space-between;
    gap: 32px;

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        gap: 16px;
        flex-direction: column;
    }
`
